import { ca } from '@cian/analytics';

function getLabel(searchString: string): string {
  const searchStringRaw = searchString.split('?');

  return searchStringRaw.length > 1 ? searchStringRaw[1] : searchStringRaw[0];
}

export function trackSearchButtonClick(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click',
    label,
  });
}

/**
 * Клик на кнопку "Показать объекты" внутри нового блока расширенных фильтров
 */
export function trackSearchButtonInAdvancedFilterClick(searchString: string) {
  const label = getLabel(searchString);

  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click_filters_block',
    label,
  });
}

/**
 * Клин на старую кнопку "Показать объекты" при открытых новых расширенных фильтрах
 */
export function trackSearchButtonWithAdvancedFilterClick(searchString: string) {
  const label = getLabel(searchString);

  ca('event', {
    name: 'oldevent',
    category: 'FastFilters',
    action: 'click_fastfilters_block',
    label,
  });
}
